var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M25.3636 8.26705L29.4972 4.13352L25.3636 0L24.4858 0.869318L27.1151 3.49858H0V4.76847H27.1151L24.4858 7.39347L25.3636 8.26705Z","fill":"#F35C25"}));
}

ArrowRight.defaultProps = {"width":"30","height":"9","viewBox":"0 0 30 9","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
